import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { Badge } from '../../../../../../models/badge';
import { BadgesService } from '../../../../../../services/badges.service';

@Injectable({
  providedIn: 'root',
})
export class BadgeResolver implements Resolve<Badge> {
  constructor(private badgesService: BadgesService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Badge> {
    return this.badgesService.getBadge(route.paramMap.get('id'), {
      invalidateCache: true,
    });
  }
}
